import { FileListComponent } from './file-list/file-list.component';
export const components: any[] = [FileListComponent];

export * from './file-list/file-list.component';
